import React from 'react';
import { PartnerSection } from 'components/Enterprise/PartnerSection';

export interface PartnerContainerProps {
  content: {
    headline: string;
    mainCta: {
      text: string;
      url: string;
    };
  };
}

export const PartnerContainer: React.FC<PartnerContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const { headline, mainCta } = content;
  return <PartnerSection headline={headline} mainCta={mainCta} />;
};

export default PartnerContainer;
